module.exports = __webpack_public_path__ + "img/gray-tick-trigger.9b718172.svg";